import React from "react";

const Tabs = ({ activeTab, setActiveTab, roles }) => {
  const tabItems = [
    { id: "all", key: "all", label: "All" },
    ...(Array.isArray(roles)
      ? roles
          .filter((role) => role.userCount > 0)
          .map((role) => ({
            id: role.roleId,
            key: role.roleId,
            label: `${role.roleName}`,
          }))
      : []),
  ];

  return (
    <div className="main-body px-[30px] pt-4 table_border flex justify-between ">
      <div className="flex mb-[30px]">
        {tabItems.map(({ key, label }, index) => {
          const isFirst = index === 0;
          const isLast = index === tabItems.length - 1;
          return (
            <>
              <div
                key={key}
                onClick={() => setActiveTab(key)}
                className="text-[18px] font-semibold text-center cursor-pointer"
                style={{ color: activeTab === key ? "#245CEA" : "black" }}
              >
                {label}
                <div
                  className={`h-1 border-b-4 relative top-2 z-1 ${
                    isFirst ? "rounded-l-md" : isLast ? "rounded-r-md" : ""
                  }`}
                  style={{
                    borderColor: activeTab === key ? "#245CEA" : "#C8D6E6",
                  }}
                />
              </div>
              {!isLast && (
                <div
                  style={{
                    color: activeTab === "active" ? "#245CEA" : "black",
                  }}
                  className="text-[18px] text-center font-semibold"
                >
                  &nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;
                  <div
                    className="h-1 border-b-4 relative top-2 z-1"
                    style={{ borderColor: "#C8D6E6" }}
                  ></div>
                </div>
              )}
              {" "}
            </>
          );
        })}
      </div>
    </div>
  );
};

export default Tabs;
